@if (isVisible) {
  <div id="promoteBanner" (click)="navigateTo(imageLink)">
    <div class="inner">
      <img [src]="imagePath" [alt]="promoteBanner.name" />
    </div>
  </div>
}
